import React from "react"
import { injectIntl } from "react-intl"
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Typography,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"

import messages from "./messages"

const useStyles = makeStyles((theme) => ({
  addPointer: {
    cursor: "pointer",
  },
  button: {
    color: "white",
    "&hover": {
      color: "#3f51b5",
    },
  },
  gridList: {
    height: "300px",
    transform: "translateZ(0)",
  },
  title: {
    color: "white",
  },
  titleBar: {
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
  vehicleTypeSelected: {
    border: "5px solid grey",
    borderRadius: "2px",
  },
}))

const VehicleCarousel = ({
  intl: { formatMessage },
  vehicleTypes,
  selectVehicleType,
  selectedVehicleType,
}) => {
  const classes = useStyles()
  if (!vehicleTypes) return null
  if (vehicleTypes.length === 0) {
    return (
      <div>
        <Typography variant="body1" gutterBottom>
          {formatMessage(messages.noVehiclesFound)}
        </Typography>
      </div>
    )
  }
  return (
    <ImageList className={classes.gridList}>
      {vehicleTypes.map((vehicleType) => (
        <ImageListItem
          className={clsx(classes.addPointer, {
            [classes.vehicleTypeSelected]: selectedVehicleType === vehicleType,
          })}
          key={vehicleType.id}
          onClick={() => selectVehicleType(vehicleType)}
        >
          <img src={vehicleType.vehicle_image_url} alt={vehicleType.name} />
          <ImageListItemBar
            title={vehicleType.name}
            classes={{
              root: classes.titleBar,
              title: classes.title,
            }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  )
}

export default injectIntl(VehicleCarousel)
